import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import AvenueImg from "../AvenueImg"

import { SlantMask } from "../WhyModule/style"

import {
  Container,
  NewFlexGrid,
  NewFlexRow,
  NewFlexCol,
  NewMainColumn,
  Title,
  GraphTitle,
  GraphItemContainer,
} from "./style"

const Graph = () => {
  const GetGraphImages = () => {
    const data = useStaticQuery(
      graphql`
        query getGraphImages {
          allFile(
            filter: { absolutePath: { regex: "/economic-images/" } }
            sort: { fields: [name], order: ASC }
          ) {
            edges {
              node {
                id
                name
                childImageSharp {
                  fluid(maxWidth: 1400) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      `
    )

    return data.allFile.edges
  }
  const allImages = GetGraphImages()

  const title = [
    "Unemployment rates",
    "Median age",
    "Drive times",
    "Weekly income",
  ]

  return (
    <Container site={"live"}>
      <SlantMask />
      <NewMainColumn>
        <Title>Economic Results & Indicators</Title>
        <NewFlexGrid>
          <NewFlexRow>
            {allImages.map((image, index) => {
              return (
                <NewFlexCol xs={6} sm={3} key={index}>
                  <GraphItemContainer>
                    <GraphTitle>{title[index]}</GraphTitle>
                    <AvenueImg fluid={image.node.childImageSharp.fluid} />
                  </GraphItemContainer>
                </NewFlexCol>
              )
            })}
          </NewFlexRow>
        </NewFlexGrid>
      </NewMainColumn>
    </Container>
  )
}

export default Graph
